import styled from 'styled-components/macro';

const InfoFile = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 80px;
  padding: 2px 10px 2px 22px;
  color: #fff;
  border: none;
  background-color: transparent;
  opacity: ${props => (props.active ? 1 : 0.6)};
  cursor: pointer;
  transition: opacity 0.25s ease-out;

  &:hover {
    opacity: 1;
  }
`;

export default InfoFile;
